module.exports = __webpack_public_path__ + "static/media/canada2.fa88de52.jpg";